import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MachineActivityServicee } from '../../../shared/services/machine-activity.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-machine-activity',
  templateUrl: './machine-activity.component.html',
  styleUrl: './machine-activity.component.scss'
})
export class MachineActivityComponent implements OnInit, OnDestroy {
  faAngleDown = faAngleDown;
  faAngleRight = faAngleRight;
  private _unsubscriber = new Subject();
  isSmallScreen: boolean = false;
  isShowed: boolean[] = [];

  @Input()
  currentMachineId!: Observable<string | undefined>;

  constructor(
    private _maSvc: MachineActivityServicee,
    private breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
    this._maSvc.IsActive = true;

    this.currentMachineId.subscribe(id => {
      if(id) {
        this._maSvc.CurrentRowId = id;
      }
    });

    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        this.isSmallScreen = state.matches;
      });
  }

  ngOnDestroy(): void {
    this._maSvc.IsActive = false;
    this._unsubscriber.next(null);
    this._unsubscriber.complete();
  }

  public get MaSvc(): MachineActivityServicee{
    return this._maSvc;
  }

  show(rowIndex: number): void {
    this.isShowed[rowIndex] = !this.isShowed[rowIndex];
  }
}
